import { isMockApi } from '@/shared/env'

/** Mock lokal — hanya saat NEXT_PUBLIC_MOCK_API=true */
export function shouldUseDelmanMock(): boolean {
  return isMockApi
}
